import React from 'react';
import { SelectInput } from 'react-admin';
import { useRateControllerContext } from '../rateController/RateControllerContext';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const RateStructureSelect = ({ source }: Props) => {
  const { setRateStructure } = useRateControllerContext();

  function onChangeRateStructure(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedValue = event.target.value as unknown as boolean;
    setRateStructure(selectedValue);
  }

  return (
    <SelectInput
      source={`${source}.use_blended_rate`}
      choices={[
        { id: false, name: '8 hour rate' },
        { id: true, name: '12 hour rate' },
      ]}
      label="Rate Structure"
      emptyText="Apply inheritance"
      onChange={onChangeRateStructure}
    />
  );
};
